<template>
  <div
    class="w-screen h-screen z-90 menu-container fixed top-0 left-0 flex flex-col items-center"
  >
    <div
      class="flex justify-between px-6 w-full p-8 lg:p-16 lg:pb-0 fixed top-0 left-0 z-50"
    >
      <img
        src="/img/expo_symbol_navy.png"
        alt="Careers Expo icon"
        class="h-16"
      />
      <button
        type="button"
        class="transform hover:rotate-180 transition-all duration-300 hover:text-expo_red z-50"
        @click="closeMenu"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
    <div
      v-if="activeMenuSlide !== 'main'"
      :style="{ paddingTop: '20vh' }"
      class="w-full flex items-center relative z-20 px-6"
      @click="goToMainMenuSlide"
    >
      <div
        class="flex items-center lg:justify-center justify-start uppercase mb-12 cursor-pointer w-full text-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M7 16l-4-4m0 0l4-4m-4 4h18"
          />
        </svg>
        <h5>Back to main menu</h5>
      </div>
    </div>
    <div class="flex flex-col items-center justify-center w-full">
      <!-- Main panel -->
      <div
        id="menuMain"
        :style="{ paddingTop: '20vh' }"
        :class="
          activeMenuSlide === 'main'
            ? 'opacity-100 translate-y-0'
            : 'translate-y-full opacity-0 pointer-events-none'
        "
        class="absolute left-0 top-0 w-full h-full flex space-x-4 transition-all duration-500 transform px-6"
      >
        <div class="w-full flex flex-col items-center">
          <div>
            <router-link
              v-if="client === 'client2'"
              class="no-underline mb-2"
              to="/"
              ><p
                class="font-poppins font-normal text-center text-lg hover:text-expo_red cursor-pointer"
                @click="closeMenu"
              >
                Home
              </p></router-link
            >
            <a
              v-else
              class="text-center text-lg no-underline font-normal text-sm hover:text-expo_red mb-2"
              :href="settings.central_domain2_url"
              ><span v-if="client === 'client2tenant'" class="font-poppins"
                >Careers Expo Home</span
              >
              <span v-else class="font-poppins">Home</span>
            </a>
          </div>
          <div>
            <p
              class="text-lg font-poppins hover:text-expo_red cursor-pointer my-2"
              @click="activeMenuSlide = 'expos'"
            >
              Upcoming Expos
            </p>
          </div>
          <div>
            <p
              class="text-lg font-poppins hover:text-expo_red cursor-pointer mb-2"
              @click="activeMenuSlide = 'online'"
            >
              Expo Online
            </p>
          </div>
          <div v-for="(item, i) in mainMenu" :key="i" class="mb-2">
            <p
              v-if="client === 'client2'"
              class="text-center font-poppins text-lg hover:text-expo_red cursor-pointer"
              @click="handleRequest(item.slug)"
            >
              {{ item.title }}
            </p>
            <a
              v-else
              class="text-center text-lg no-underline font-normal text-sm hover:text-expo_red"
              :href="settings.central_domain2_url + '/' + item.slug"
              >{{ item.title }}</a
            >
          </div>
        </div>
      </div>

      <!-- Upcoming Expos panel -->
      <div
        id="menuExpos"
        :style="{ paddingTop: '30vh' }"
        :class="
          activeMenuSlide === 'expos'
            ? 'opacity-100 translate-y-0'
            : 'translate-y-full opacity-0 pointer-events-none'
        "
        class="absolute left-0 top-0 w-full h-full flex space-x-4 transition-all duration-500 transform px-6 z-10"
      >
        <div class="w-5/12 lg:w-1/2">
          <h4 class="text-expo_red text-right text-base uppercase">
            Locations <span class="mx-2">|</span>
          </h4>
        </div>
        <div class="w-7/12 lg:w-1/2">
          <div v-for="(item, i) in events" :key="i" class="mb-2">
            <p
              v-if="client === 'client2'"
              class="text-lg font-poppins hover:text-expo_red cursor-pointer"
              @click="goToEvent(item.slug)"
            >
              {{ item.title }}
            </p>
            <a
              v-else
              class="text-lg font-poppins no-underline font-normal text-sm hover:text-expo_red"
              :href="settings.central_domain2_url + '/event/' + item.slug"
              >{{ item.title }}</a
            >
          </div>
        </div>
      </div>

      <!-- Online Expo panel -->
      <div
        id="menuOnline"
        :style="{ paddingTop: '30vh' }"
        :class="
          activeMenuSlide === 'online'
            ? 'opacity-100 translate-y-0'
            : 'translate-y-full opacity-0 pointer-events-none'
        "
        class="absolute left-0 top-0 w-full h-full flex space-x-4 transition-all duration-500 transform px-6 z-10"
      >
        <div class="w-5/12 lg:w-1/2">
          <h4 class="text-expo_red text-right text-base uppercase">
            Expo Online <span class="mx-2">|</span>
          </h4>
        </div>
        <div class="w-7/12 lg:w-1/2">
          <div v-for="(item, i) in onlineMenu" :key="i" class="mb-2">
            <p
              v-if="client === 'client2cloud'"
              class="text-lg font-poppins hover:text-expo_red cursor-pointer"
              @click="handleRequest(item.slug)"
            >
              {{ item.title }}
            </p>
            <a
              v-else
              class="text-lg no-underline font-normal text-sm hover:text-expo_red"
              :href="settings.cloud_url + '/' + item.slug"
              >{{ item.title }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shared } from '../js/mixins/shared.js'
import { EventBus } from '../js/plugins/event-bus.js'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {},
  mixins: [shared],

  data() {
    return {
      activeMenuSlide: 'main',
      mainMenu: [
        {
          title: 'For Exhibitors',
          slug: 'for-exhibitors',
        },
        {
          title: 'For Schools',
          slug: 'for-schools',
        },
        {
          title: 'World of Work',
          slug: 'world-of-work',
        },
        {
          title: 'Contact',
          slug: 'contact-us',
        },
      ],

      onlineMenu: [
        {
          title: 'Online Expo',
          slug: '',
        },
        {
          title: 'Exhibitor Latest News',
          slug: 'exhibitor-latest-news',
        },
      ],
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
      client: 'shared/getClient',
      events: 'expo/getEvents',
    }),
  },

  async mounted() {
    if (this.events.length < 1) {
      await this.dispatchSetEvents()
    }
  },

  methods: {
    ...mapActions({
      dispatchSetEvents: 'expo/dispatchSetEvents',
    }),

    closeMenu() {
      EventBus.$emit('toggleExpoMenuContent')
    },

    goToMainMenuSlide() {
      this.$set(this, 'activeMenuSlide', 'main')
    },

    goToEvent(slug) {
      // Be wary of pushing to the same template
      // If on the event template already we need to replace
      // If not on the event template we can push
      if (this.$router.history.current.name === 'Event') {
        this.$router.replace({ path: '/event/' + slug, params: { slug: slug } })
      } else {
        this.$router.push({ path: '/event/' + slug })
      }
      this.closeMenu()
    },

    handleRequest(item) {
      this.$router.push({ path: '/' + item })
      this.closeMenu()
    },
  },
}
</script>

<style scoped>
.menu-container {
  background: rgba(255, 255, 255, 0.98);
}
</style>
